let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hbMg4")).then(() => parcelRequire('6l70f'));